(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-before-after-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bl-before-after-image')) {
    customElements.define(
      'bl-before-after-image',
      class extends HTMLElement {
        connectedCallback() {
          this.range = this.querySelector('[data-bl-ba-range]');
          this.media = this.querySelector('[data-bl-ba-media]');
          if (!this.range || !this.media) return;
          this.update = this.update.bind(this);
          this.range.addEventListener('input', this.update);
          this.update();
        }

        disconnectedCallback() {
          if (this.range) this.range.removeEventListener('input', this.update);
        }

        update() {
          const value = Math.min(100, Math.max(0, Number(this.range.value)));
          this.media.style.setProperty('--bl-ba-position', `${value}%`);
          this.range.setAttribute('aria-valuenow', String(value));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-testimonial-33"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bl-testimonial-33')) {
    customElements.define(
      'bl-testimonial-33',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-blt33-track]');
          this.previousButton = this.querySelector('[data-blt33-previous]');
          this.nextButton = this.querySelector('[data-blt33-next]');
          if (!this.track) return;

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.updateButtons());
          this.resizeObserver.observe(this.track);
          this.updateButtons();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        move(direction) {
          const card = this.track.querySelector('.blt33__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        updateButtons() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-timeline-4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bl-timeline')) {
    class BLTimeline extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.viewport = this.querySelector('[data-bl-timeline-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-bl-timeline-slide]'));
        this.contents = Array.from(this.querySelectorAll('[data-bl-timeline-content]'));
        this.bullets = Array.from(this.querySelectorAll('[data-bl-timeline-bullet]'));
        this.previousButton = this.querySelector('[data-bl-timeline-prev]');
        this.nextButton = this.querySelector('[data-bl-timeline-next]');
        this.currentIndex = 0;
        this.scrollTimer = null;

        if (!this.viewport || this.slides.length === 0) return;

        this.slides.forEach((slide, index) => {
          slide.addEventListener('click', () => this.setActive(index, true));
        });

        this.bullets.forEach((bullet, index) => {
          bullet.addEventListener('click', () => this.setActive(index, true));
        });

        this.previousButton?.addEventListener('click', () => {
          this.setActive((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
        });

        this.nextButton?.addEventListener('click', () => {
          this.setActive((this.currentIndex + 1) % this.slides.length, true);
        });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setActive((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.setActive((this.currentIndex + 1) % this.slides.length, true);
          }
        });

        this.viewport.addEventListener('scroll', () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.activateNearestSlide(), 90);
        }, { passive: true });

        this.setActive(0, false);
        window.requestAnimationFrame(() => this.centerSlide(0, false));
      }

      setActive(index, shouldScroll) {
        const safeIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.currentIndex = safeIndex;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === safeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-pressed', String(isActive));
        });

        this.contents.forEach((content, contentIndex) => {
          const isActive = contentIndex === safeIndex;
          content.classList.toggle('is-active', isActive);
          content.hidden = !isActive;
        });

        this.bullets.forEach((bullet, bulletIndex) => {
          const isActive = bulletIndex === safeIndex;
          bullet.classList.toggle('is-active', isActive);
          bullet.setAttribute('aria-current', String(isActive));
        });

        if (shouldScroll) this.centerSlide(safeIndex, true);
      }

      centerSlide(index, smooth) {
        const slide = this.slides[index];
        if (!slide || !this.viewport) return;
        const left = slide.offsetLeft - (this.viewport.clientWidth - slide.clientWidth) / 2;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          left,
          behavior: smooth && !reduceMotion ? 'smooth' : 'auto'
        });
      }

      activateNearestSlide() {
        if (!this.viewport) return;
        const viewportCenter = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(viewportCenter - slideCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        if (nearestIndex !== this.currentIndex) this.setActive(nearestIndex, false);
      }
    }

    customElements.define('bl-timeline', BLTimeline);

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-bl-timeline-slide]');
      const timeline = event.target.closest('bl-timeline');
      if (!slide || !timeline) return;
      const index = Number(slide.dataset.blTimelineSlide);
      timeline.setActive(index, true);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
